import UserApi from 'app/api/UserApi';
import { userUpdateFromUserDto } from 'app/types/User';
import { UserStatus, parseFromUser } from 'app/types/UserStatus';
import { RequireAuth, UserRole, useRequireAuth } from 'legoland-sdk/dist/experimental';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Button, Menu, tombac, useToasts } from 'tombac';
import { DeleteIcon, EmailIcon, LockIcon, MenuKebabIcon, ShareLinkIcon, UnlockIcon } from 'tombac-icons';
import { useUserMutation } from "../api/userManagementApiHooks";
import { ActivationLinkModal } from "./ActivationLinkModal";
import { DeleteUserConfirmModal } from "./DeleteUserConfirmModal";
import { EditEmailIcon } from "./EditEmailIcon";
import { EditUserEmailModal } from "./EditUserEmailModal";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export function UserActions({
  user
}) {
  const {
    mutateAsync: updateUser
  } = useUserMutation();
  const status = parseFromUser(user);
  const userUpdate = userUpdateFromUserDto(user);
  const {
    addToast
  } = useToasts();
  const history = useHistory();
  const [isEditEmailModalOpen, setIsEditEmailModalOpen] = useState(false);
  const [isActivationLinkModalOpen, setIsActivationLinkModalOpen] = useState(false);
  const [isConfirmDeleteUserModalOpen, setIsConfirmDeleteUserModalOpen] = useState(false);
  const {
    hasValidRole: isAdmin
  } = useRequireAuth({
    role: UserRole.Admin
  });
  const handleAction = key => {
    switch (key) {
      case 'resendEmail':
        UserApi.resendEmail(user.email).then(() => addToast('Activation email sent', 'success'));
        break;
      case 'editEmail':
        setIsEditEmailModalOpen(true);
        break;
      case 'activationLink':
        setIsActivationLinkModalOpen(true);
        break;
      case 'lock':
        updateUser({
          update: {
            ...userUpdate,
            accountNotLocked: false
          }
        }).then(() => addToast('Account is locked', 'success'));
        break;
      case 'unlock':
        updateUser({
          update: {
            ...userUpdate,
            accountNotLocked: true
          }
        }).then(() => addToast('Account is unlocked', 'success'));
        break;
      case 'delete':
        setIsConfirmDeleteUserModalOpen(true);
        break;
    }
  };
  const deleteUser = async () => {
    try {
      const data = await updateUser({
        update: {
          ...userUpdate,
          isArchived: true
        }
      });
      history.replace(`/users/edit/${encodeURIComponent(data.content[0].email)}`);
      addToast('Deleted account', 'success');
    } catch (e) {
      const error = await e.json();
      addToast(error?.message || 'Unable to delete account', 'danger');
    }
  };
  const resendEmail = /*#__PURE__*/_jsx(Menu.Item, {
    prepend: /*#__PURE__*/_jsx(EmailIcon, {}),
    children: "Resend activation email"
  }, "resendEmail");
  const editEmail = isAdmin && /*#__PURE__*/_jsx(Menu.Item, {
    prepend: /*#__PURE__*/_jsx(EditEmailIcon, {}),
    children: "Edit email"
  }, "editEmail");
  const activationLink = isAdmin && /*#__PURE__*/_jsx(Menu.Item, {
    prepend: /*#__PURE__*/_jsx(ShareLinkIcon, {}),
    children: "Get activation link"
  }, "activationLink");
  const lock = /*#__PURE__*/_jsx(Menu.Item, {
    prepend: /*#__PURE__*/_jsx(LockIcon, {}),
    children: "Lock"
  }, "lock");
  const unlock = /*#__PURE__*/_jsx(Menu.Item, {
    prepend: /*#__PURE__*/_jsx(UnlockIcon, {}),
    children: "Unlock"
  }, "unlock");
  const deleteButton = isAdmin && /*#__PURE__*/_jsx(Menu.Item, {
    $color: tombac.color('danger'),
    prepend: /*#__PURE__*/_jsx(DeleteIcon, {}),
    children: "Delete"
  }, "delete");
  let actionItems;
  switch (status) {
    case UserStatus.Locked:
      actionItems = [unlock, deleteButton];
      break;
    case UserStatus.Inactive:
      actionItems = [resendEmail, editEmail, activationLink, lock, deleteButton];
      break;
    case UserStatus.Deleted:
      actionItems = [];
      break;
    default:
      actionItems = [editEmail, lock, deleteButton];
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Menu.Dropdown, {
      onAction: handleAction,
      placement: "bottom end",
      trigger: ({
        triggerProps
      }) => /*#__PURE__*/_jsx(Button, {
        ...triggerProps,
        shape: "circle",
        children: /*#__PURE__*/_jsx(MenuKebabIcon, {})
      }),
      "data-sentry-element": "unknown",
      "data-sentry-source-file": "UserActions.tsx",
      "data-sentry-element": "unknown",
      children: actionItems
    }), /*#__PURE__*/_jsxs(RequireAuth, {
      role: UserRole.Admin,
      "data-sentry-element": "RequireAuth",
      "data-sentry-source-file": "UserActions.tsx",
      "data-sentry-element": "RequireAuth",
      children: [actionItems.includes(editEmail) && /*#__PURE__*/_jsx(EditUserEmailModal, {
        isOpen: isEditEmailModalOpen,
        onRequestClose: () => setIsEditEmailModalOpen(false)
      }), actionItems.includes(activationLink) && /*#__PURE__*/_jsx(ActivationLinkModal, {
        isOpen: isActivationLinkModalOpen,
        onRequestClose: () => setIsActivationLinkModalOpen(false)
      }), actionItems.includes(deleteButton) && /*#__PURE__*/_jsx(DeleteUserConfirmModal, {
        isOpen: isConfirmDeleteUserModalOpen,
        onRequestClose: () => setIsConfirmDeleteUserModalOpen(false),
        onConfirm: deleteUser
      })]
    })]
  });
}